var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m329.066 333.388c-7.69-1.318-13.066-7.368-13.066-14.722v-47.666h-60-60v47.666c0 7.354-5.376 13.403-13.066 14.722-73.067 12.524-151.934 79.252-151.934 163.612v15h210l15-31 15 31h210v-15c0-84.36-78.867-151.088-151.934-163.612z",
    fill: "#cef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481 512v-15c0-84.36-78.867-151.088-151.934-163.612-7.69-1.318-13.066-7.368-13.066-14.722v-47.666h-60v210l15 31z",
    fill: "#b3d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361 171.099v-50.099l-30-15h-75-75l-30 15v50.099l-15 16.201 15 17.399v21.301c0 3.9.3 8.101.901 12.001h104.099 104.099c.601-3.9.901-8.101.901-12.001v-21.301l15-16.199z",
    fill: "#ffe1ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361 226v-21.301l15-16.199-15-17.401v-50.099l-30-15h-75v132.001h104.099c.601-3.9.901-8.101.901-12.001z",
    fill: "#fc9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346 421h60v30h-60z",
    fill: "#efe2dd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 211c-42.07 0-69.163 16.408-104.099 27.001 4.295 48.73 48.027 92.999 104.099 92.999 56.016 0 99.813-44.375 104.099-92.999-35.429-10.741-61.976-27.001-104.099-27.001z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.099 238.001c-35.429-10.741-61.976-27.001-104.099-27.001v120c56.016 0 99.813-44.375 104.099-92.999z",
    fill: "#efe2dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361 171.25v33.521c20.381 12.662 28.852 30.736 24.902 54.086-9.067 53.642-79.482 117.143-129.902 117.143-50.186 0-120.337-63.706-129.434-117.524-3.942-23.339 4.376-41.336 24.434-53.866v-33.523c-41.223 18.034-60.992 51.086-54.023 92.384 10.827 64.079 81.566 131.444 144.023 141.201v107.328h15 15v-107.313c62.701-9.699 133.689-76.913 144.492-140.836 6.967-41.248-12.986-74.362-54.492-92.601z",
    fill: "#404080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 404.687c62.701-9.699 133.689-76.913 144.492-140.836 6.967-41.248-12.986-74.363-54.492-92.602v33.521c20.381 12.662 28.852 30.736 24.902 54.086-9.067 53.643-79.482 117.144-129.902 117.144v136h15z",
    fill: "#282866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0h-105v91l30 15h75 75l30-15v-91z",
    fill: "#cef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361 91v-91h-105v106h75z",
    fill: "#b3d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 91h-105v30h105 105v-30z",
    fill: "#404080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 91h105v30h-105z",
    fill: "#282866"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 106,
    fill: "#fff5f5",
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 106c0-24.814-20.186-45-45-45v90c24.814 0 45-20.186 45-45z",
    fill: "#efe2dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 106,
    fill: "#efe2dd",
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 106c0-8.276-6.724-15-15-15v30c8.276 0 15-6.724 15-15z",
    fill: "#e1d3ce"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.2a4189a741d0cce9a7b63bae21762d72.svg";
export { ForwardRef as ReactComponent };